

export default (state = [], action) => {
  if (action.type == "SET_ROSHHASHANA") {
    return action.value;
  }
  return state;
};